import { render, staticRenderFns } from "./MailGroupActions.vue?vue&type=template&id=1d92ff75"
import script from "./MailGroupActions.vue?vue&type=script&lang=js"
export * from "./MailGroupActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports